import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { EventChangesFragment, EventBasicDetailsChanges } from './common';

type UpdateEventNotificationSettingsInput = {
  sendCalendarEmail: boolean;
  sendSlack: boolean;
  resetRsvps: boolean;
};

type UpdateEventBasicDetailsPayloadInput =
  | {
      type: 'single';
      id: number;
      photoUrl: string;
      title: string;
      datetimeScheduled: string;
      datetimeEnd: string;
      timezoneCode: string;
      allDay: boolean;
      isVirtual: boolean;
      isInPerson: boolean;
      locationAddress?: string;
      virtualLink?: string;
      zoomMeetingId?: number;
      googleMeetingId?: number;
      description: string;
      isPrivate: boolean;
      teamId: number;
      companyLocationId?: number;
      t2DomainArray?: string[];
    }
  | {
      type: 'multi-sessions';
      id: number;
      photoUrl: string;
      title: string;
      description: string;
      isPrivate: boolean;
      teamId: number;
      companyLocationId?: number;
      timezoneCode: string;
      t2DomainArray?: string[];
    };

type EventBasicDetailsChangesResult = {
  eventBasicDetailsChanges: EventBasicDetailsChanges;
};

const GET_EVENT_BASIC_DETAILS_CHANGES_QUERY = gql`
  query getEventBasicDetailsChanges(
    $eventId: Int!
    $payload: UpdateEventBasicDetailsPayloadInput!
  ) {
    eventBasicDetailsChanges(eventId: $eventId, payload: $payload) {
      ...EventChangesFragment
    }
  }
  ${EventChangesFragment}
`;

type UpdateEventBasicDetailsResult = {
  updateEventBasicDetails: {
    ok: boolean;
    zoomSyncFailed: boolean | null;
    event: {
      id: number;
    };
  };
};

const UPDATE_EVENT_BASIC_DETAILS_MUTATION = gql`
  mutation updateEventBasicDetails($input: UpdateEventBasicDetailsInput!) {
    updateEventBasicDetails(input: $input) {
      ok
      zoomSyncFailed
      event {
        id
      }
    }
  }
`;

const eventBasicDetailsApi = {
  getChanges: async ({
    eventId,
    payload: { type: _, ...payload } // omit `type` from payload
  }: {
    eventId: number;
    payload: UpdateEventBasicDetailsPayloadInput;
  }): Promise<EventBasicDetailsChanges> => {
    return gqlClient
      .request<EventBasicDetailsChangesResult>(GET_EVENT_BASIC_DETAILS_CHANGES_QUERY, {
        eventId,
        payload
      })
      .then((res) => res.eventBasicDetailsChanges);
  },

  update: async ({
    eventPayload: { type: _, ...eventPayload }, // omit `type` from eventPayload
    updateNotificationSettings
  }: {
    eventPayload: UpdateEventBasicDetailsPayloadInput;
    updateNotificationSettings?: UpdateEventNotificationSettingsInput;
  }): Promise<UpdateEventBasicDetailsResult['updateEventBasicDetails']> => {
    return gqlClient
      .request<UpdateEventBasicDetailsResult>(UPDATE_EVENT_BASIC_DETAILS_MUTATION, {
        input: {
          eventPayload,
          updateNotificationSettings
        }
      })
      .then((res) => res.updateEventBasicDetails);
  }
};

export {
  eventBasicDetailsApi,
  type UpdateEventBasicDetailsPayloadInput,
  type UpdateEventNotificationSettingsInput
};
